import $ from 'jquery'
import messageResource from '../../messageResource'

export default function ChartPercentsCheckbox() {};

ChartPercentsCheckbox.prototype.init = function( containerId, changeShowPercents, showPercents )
{
    this.container = $( "#" + containerId );
    this.container.empty();
    this.checkbox = $( "<input type='checkbox' id='chartShowPercentsCheckbox'>" );

    this.setPercentsCheckboxValue( showPercents );

    this.checkbox.click( function(e) {
        changeShowPercents( e.target.checked );
    });

    this.container.append(
            this.checkbox,
            $( "<label for='chartShowPercentsCheckbox'>" + messageResource.getMessage( "report.create_chart.show_percent_values" ) + "</label>" )
    );

    return this;
};

ChartPercentsCheckbox.prototype.setPercentsCheckboxValue = function( value )
{
    if ( value )
        this.checkbox.attr( "checked", "checked" );
    else
        this.checkbox.removeAttr( "checked" );
};

ChartPercentsCheckbox.prototype.hidePercentsCheckbox = function () {
    this.container.addClass( "hidden" );
};

ChartPercentsCheckbox.prototype.showPercentsCheckbox = function () {
    this.container.removeClass( "hidden" );
};

ChartPercentsCheckbox.prototype.getValue = function()
{
    return !!this.checkbox.attr( "checked" );
};

ChartPercentsCheckbox.prototype.isVisibleAndChecked = function()
{
    return !this.container.hasClass( "hidden" ) && !!this.checkbox.attr( "checked" );
};


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartPercentsCheckbox.js